const COMPANY_ENDPOINT = '/company';
const AUTH_ENDPOINT = '/auth';

export { COMPANY_ENDPOINT, AUTH_ENDPOINT };
